<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('trailer.returnCodeActivation')"
      :visible.sync="addDialog"
      top="5vh"
      width="500px"
      @close="resetForm('ruleForm')"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <!--  配置类型  -->
            <el-form-item :label="$t('trailer.configurationType')" prop="configType">
              <el-select
                v-model="ruleForm.configType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%"
                @change="changeConfigType"
              >
                <el-option key="1" :label="$t('trailer.byState')" :value="1" />
                <el-option key="2" :label="$t('trailer.byHub')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.configType === 1" key="state_col" :span="24">
            <!-- 配置的州  -->
            <el-form-item :label="$t('trailer.configuredStates')" prop="stateCode">
              <el-select
                v-model="ruleForm.stateCode"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in stateList"
                  :key="`state_${item.id}`"
                  :label="item.nameEn"
                  :value="item.nameEn"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="ruleForm.configType === 2" key="site_col" :span="24">
            <!-- 配置的网点   -->
            <el-form-item :label="$t('trailer.configuredHubs')" prop="siteIds">
              <el-select
                v-model="ruleForm.siteIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getSiteList"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @clear="clearnSiteIdFun"
                @focus="getSiteList1"
              >
                <el-option
                  v-for="item in siteList"
                  :key="`site_${item.id}`"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 退件码时效  -->
            <el-form-item :label="$t('trailer.returnCodeValidityHours')" prop="validityHours">
              <el-input
                v-model.number="ruleForm.validityHours"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                clearable
                maxlength="6"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 状态 -->
            <el-form-item :label="$t('GlobalSetObj.status')" prop="status">
              <el-radio-group v-model="ruleForm.status">
                <el-radio-button :label="1">{{ $t('GlobalSetObj.enable') }}</el-radio-button>
                <el-radio-button :label="0">{{ $t('GlobalSetObj.stop') }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div style="text-align: right">
              <el-button
                size="small" @click="resetForm('ruleForm')"
              >{{ $t('roleManage.cancel') }}
              </el-button>
              <el-button
                size="small" type="primary" @click="submitForm('ruleForm')"
              >{{ $t('roleManage.confirm') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getLgAreaListData, loadUnloadSumuserAndSite } from '@/api/orderApi';
import { returnCodeConfigAdd, returnCodeConfigUpdate } from '@/api/newExpressAPI';
import { getAllsite } from '@/api/logisticsOrders';

export default {
  data() {
    return {
      addDialog: false,
      ruleForm: {
        configType: 1,
        siteIds: [],
        stateCode: '',
        status: 1,
        validityHours: ''
      },
      stateList: [],
      rules: {
        configType: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        stateCode: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        siteIds: [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        status: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        validityHours: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          },
          {
            // 自定义正则校验器
            validator: (rule, value, callback) => {
              // 正则规则：仅允许数字，最多保留2位小数（支持整数、0开头小数如0.12、非0开头如123.45）
              const reg = /^[1-9]\d*$/;
              // 空值已由required校验，此处无需重复判断
              if (!reg.test(value)) {
                // 提示语可替换为你的国际化文案
                callback(new Error(this.$t('GlobalSetObj.enterValidTime')));
              } else {
                // 校验通过
                callback();
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      showImg: true,
      editId: null,
      siteList: []
    };
  },
  methods: {
    clearnSiteIdFun() {
      this.siteList = [];
      this.getSiteList('');
    },
    getSiteList(val) {
      const data = {
        siteName: val
      };
      loadUnloadSumuserAndSite(data).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data.siteList;
        }
      });
    },
    getSiteList1() {
      if (this.siteList.length === 0) {
        this.getSiteList('');
      }
    },
    // 获取所有网点
    getAllSite() {
      getAllsite().then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    changeConfigType() {
      if (this.ruleForm.configType === 1) {
        this.ruleForm.stateCode = '';
        this.ruleForm.siteIds = [];
        this.rules.stateCode = [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ];
        this.rules.siteIds = [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ];
        this.siteList = [];
      } else {
        this.ruleForm.stateCode = '';
        this.ruleForm.siteIds = [];
        this.rules.stateCode = [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ];
        this.rules.siteIds = [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ];
      }
    },
    // 加载弹框
    showEventDialog(arg) {
      console.log(arg);
      if (arg) {
        this.editId = arg.id;
        this.getAllSite();
        this.ruleForm.configType = arg.configType;
        this.ruleForm.siteIds = arg.siteIds;
        this.ruleForm.stateCode = arg.stateCode;
        this.ruleForm.status = arg.status;
        this.ruleForm.validityHours = arg.validityHours;
        if (arg.configType === 1) {
          this.rules.stateCode = [
            {
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }
          ];
          this.rules.siteIds = [
            {
              required: false,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }
          ];
        } else {
          this.rules.stateCode = [
            {
              required: false,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }
          ];
          this.rules.siteIds = [
            {
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }
          ];
        }
      } else {
        this.editId = null;
      }
      this.getStateList();
      this.addDialog = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            configType: this.ruleForm.configType,
            siteIds: this.ruleForm.siteIds,
            stateCode: this.ruleForm.stateCode,
            status: this.ruleForm.status,
            validityHours: Number(this.ruleForm.validityHours)
          };
          if (this.editId) {
            data.id = this.editId;
            returnCodeConfigUpdate(data).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.$refs[formName].resetFields();
                this.addDialog = false;
                this.$emit('search');
              }
            });
          } else {
            returnCodeConfigAdd(data).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.$refs[formName].resetFields();
                this.addDialog = false;
                this.$emit('search');
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {
        configType: 1,
        siteIds: [],
        stateCode: '',
        status: 1,
        validityHours: ''
      };
      this.rules.stateCode = [
        {
          required: true,
          message: this.$t('GlobalSetObj.pleaseChoose'),
          trigger: ['blur', 'change']
        }
      ];
      this.rules.siteIds = [
        {
          required: false,
          message: this.$t('GlobalSetObj.pleaseChoose'),
          trigger: ['blur', 'change']
        }
      ];
      this.siteList = [];
      this.$refs[formName].resetFields();
      this.addDialog = false;
    },
    // 州
    getStateList() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped></style>
